import { withConfig, withTranslationResources } from '@/router/navigationGuards';
import { RouteRecordRaw } from 'vue-router';

export const translationRoute: RouteRecordRaw = {
  name: 'TranslationView',
  path: '/translate',
  component: () => import('@/modules/Translation/views/TranslationView.vue'),
  beforeEnter: [withTranslationResources, withConfig],
  meta: {
    titleLocalizationKey: 'SKILLS.translate',
  },
};
